import React, {ComponentType} from "react";
import NewBookingNav from "./index";
import {IProps, IServices, IHandlers} from './types';
import AppThemeService from 'app/services/theme/appTheme.service';

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import {IDiaryTheme} from "app/types/common.types";

const NS = 'NewBookingNavContainer';

const propsKeys: string[] = keys<IProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const theme: IDiaryTheme = AppThemeService.getAppTheme();

const ThemeWrap = function(all: IProps & IHandlers & IServices) {

  const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {

  }

  return ReactUtilsService.containerWrap(
    <NewBookingNav {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ANewBookingNav: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...propsKeys, ...handlersKeys] as never[],
  servicesKeys
];
